<template>

    <b-modal id="payroll-form-modal" ref="payrollModalRef" v-model="show" centered modal-class="a4-portrait no-header no-footer">
        <div class="p-1 overflow-auto h-100 p-relative">
            <div class="floating-header">
                <a href="#" class="bg-white d-block px-2 py-1 text-orange">Download PDF</a>
                <a href="#" class="bg-white d-block px-2 py-1 ml-1 text-orange" @click="show=false">
                    <i class="fa fa-times" />
                </a>
            </div>
            <div class="d-flex">
                <div class="flex-shrink-1">
                    <h5 class="text-nowrap font-weight-bold">U.S. Department of Labor</h5>
                    <div>Wage and Hour Division</div>
                </div>

                <div class="text-center flex-grow-1">
                    <h5 class="font-weight-bold">PAYROLL</h5>
                    <h6>(For Contractor's Optional Use; See Instructions at www.dol.gov/whd/forms/wh347instr.htm)</h6>
                    <small><i>Persons are not required to respond to the collection of information unless it displays a
                            currently valid OMB control number.</i></small>
                </div>

                <div class="flex-shrink-1 text-center">
                    <img src="~/assets/img/icons/whd-icon.png" class="d-block m-auto" style="width: 150px"
                        alt="U.S. Wage and Hour Division">
                    <small class="text-danger d-block">U.S. Wage and Hour Division</small>
                    <div>Rev. Dec. 2008</div>
                </div>
            </div>

            <div class="d-flex border-top border-bottom border-dark font-sm">
                <div class="px-1 w-50">
                    <div class="d-inline-block mr-5">
                        NAME OF CONTRACTOR
                        <div class="checkbox" :class="{ 'checked': (name_type == 'contractor') }"></div>
                    </div>
                    <div class="d-inline-block">
                        OR SUBCONTRACTOR
                        <div class="checkbox" :class="{ 'checked': (name_type == 'subcontractor') }"></div>
                    </div>
                    <div class="input mt-1 w-full">
                        {{ name }}
                    </div>
                </div>

                <div class="border-right border-left border-dark px-1 d-flex flex-grow-1">
                    <div>ADDRESS</div>
                    <div class="input w-100 mx-1">
                        {{ address }}
                    </div>
                </div>

                <div class="pl-2 flex-shrink-1">
                    <div>OMB No: 1235-0008</div>
                    <div>Expires: 09/30/2026</div>
                </div>
            </div>
            <div class="d-flex font-sm">
                <div class="px-1 pt-1 d-flex w-25">
                    <div>PAYROLL NO.</div>
                    <div class="input mx-1 flex-grow-1">
                        {{ payroll_no }}
                    </div>
                </div>
                <div class="d-flex px-1 pt-1 border-left border-dark w-25">
                    <div>FOR WEEK ENDING</div>
                    <div class="input mx-1 flex-grow-1">
                        {{ week_ending }}
                    </div>
                </div>
                <div class="border-left border-right border-dark px-1 pt-1">
                    <div>PROJECT AND LOCATION</div>
                    <div class="input mx-1" style="width: 250px; height: 35px">
                        {{ project_location }}
                    </div>
                </div>
                <div class="px-1 pt-1 flex-grow-1">
                    <div>PROJECT OR CONTRACT NO.</div>
                    <div class="input mx-1 w-full" style="height: 35px">
                        {{ project_no }}
                    </div>
                </div>
            </div>


            <table bordercolor="#808184" class="text-center line-height-2 font-sm" width="100%" cellpadding="1"
                cellspacing="0" border-collapse="collapse">
                <tr>
                    <td>
                        (1)<br>
                        NAME AND INDIVIDUAL IDENTIFYING NUMBER<br>
                        (e.g., LAST FOUR DIGITS OF SOCIAL SECURITY<br>
                        NUMBER) OF WORKER
                    </td>
                    <td style="width: 50px">
                        <div class="mb-2">(2)</div>
                        <div class="text-vertical text-left line-height-2">EXEMPTIONS<br>WITHHOLDING<br>NO. OF </div>
                    </td>
                    <td>
                        (3)<br>
                        WORK<br> CLASSIFICATION
                    </td>
                    <td class="text-vertical line-height-2 p-0" style="width: 1px; padding: 0; margin-left: -3px">
                        OT. OR ST
                    </td>
                    <td style="width: 1px; padding: 0">
                        <div class="mb-2">(4) DAY AND DATE</div>
                        <table cellpadding="0" cellspacing="0">
                            <tr>
                                <td v-for="i in 7" :key="i" class="input p-1" style="height: 26px;">
                                    {{ moment().startOf('isoWeek').add(i - 1, 'days').format('D') }}
                                </td>
                            </tr>
                            <tr>
                                <td v-for="i in 7" :key="i" class="input p-1" style="height: 26px;">
                                    {{ moment().startOf('isoWeek').add(i - 1, 'days').format('dd') }}
                                </td>
                            </tr>
                        </table>
                        <div>HOURS WORKED EACH DAY</div>
                    </td>
                    <td style="width: 1px;">
                        <div>(5)</div>
                        <div>TOTAL HOURS</div>
                    </td>
                    <td>
                        (6)<br>
                        RATE OF PAY
                    </td>
                    <td>
                        (7)<br>
                        GROSS<br> AMOUNT<br> EARNED
                    </td>
                    <td class="p-0" valign="bottom">
                        (8)<br>
                        DEDUCTIONS
                        <table cellpadding="1" cellspacing="0" style="margin: 10px -1px -1px -1px">
                            <tr>
                                <td style="width: calc(100%/6);">FICA</td>
                                <td style="width: calc(100%/6);">WITH-<br>HOLDING<br>TAX</td>
                                <td class="input" style="width: calc(100%/6);"></td>
                                <td class="input" style="width: calc(100%/6);"></td>
                                <td style="width: calc(100%/6);">OTHER</td>
                                <td style="width: calc(100%/6);">TOTAL<br>DEDUCTIONS</td>
                            </tr>
                        </table>

                    </td>
                    <td>
                        (9)<br>
                        NET<br>
                        WAGES<br>
                        PAID<br>
                        FOR WEEK
                    </td>
                </tr>
                <tr v-for="(worker, index) in workers" :key="worker.id">
                    <td class="input text-left">
                        {{ worker.first_name }} {{ worker.last_name }}<br>
                        <span class="mr-3">{{ faker.address.streetAddress() }}</span>
                        <span class="float-right">{{ faker.address.city() }}</span><br>
                        <span class="mr-3">{{ faker.phone.phoneNumber() }}</span>
                        <span class="float-right">SSN: XXXX-XX-{{ faker.datatype.number({ 'min': 1000, 'max': 9999 })
                            }}</span>

                    </td>
                    <td>
                        <div class="input">{{ faker.datatype.number({ min: 0, max: 4 }) }}</div>
                    </td>
                    <td data-ref="work-classification" class="input">
                        <span v-if="worker.is_apprentice">Apprentice</span>
                        <span v-else>Journeyman</span>
                    </td>
                    <td class="p-0 h-100">
                        <table class="h-100">
                            <tr class="h-50">
                                <td>O</td>
                            </tr>
                            <tr class="h-50">
                                <td>S</td>
                            </tr>
                        </table>
                    </td>
                    <td class="p-0 h-100">
                        <table class="h-100 w-100">
                            <tr class="h-50">
                                <td v-for="i in 7" :key="i" class="input p-1 h-50" style="width: calc(100%/7)">
                                </td>
                            </tr>
                            <tr class="h-50">
                                <td v-for="i in 7" :key="i" class="input p-1 h-50">
                                    <span v-if="i <= 2 && index <= 3">8</span>
                                    <span v-else-if="i > 4 && index > 3">8</span>
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td data-ref="total-hours" class="p-0 h-100">
                        <table class="h-100 w-100">
                            <tr class="h-50">
                                <td class="p-1 h-50">
                                    0
                                </td>
                            </tr>
                            <tr class="h-50">
                                <td class="p-1 h-50">
                                    <span v-if="index <= 3">16</span>
                                    <span v-else>24</span>
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td data-ref="rate-of-pay" class="p-0 h-100">
                        <table class="h-100 w-100">
                            <tr class="h-50">
                                <td class="p-1 h-50 input">
                                    0.00
                                </td>
                            </tr>
                            <tr class="h-50">
                                <td class="p-1 h-50 input">
                                    {{ faker.finance.amount(15, 40) }}
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td>
                        <div></div>
                        <div>/</div>
                        <div></div>
                    </td>
                    <td data-ref="deductions" class="p-0 border-0">
                        <table class="w-100 h-100">
                            <tr>
                                <td class="input"></td>
                                <td class="input"></td>
                                <td class="input"></td>
                                <td class="input"></td>
                                <td class="input"></td>
                                <td class="input"></td>
                            </tr>
                        </table>

                    </td>
                    <td></td>
                </tr>
            </table>

            <div class="font-sm border-bottom border-dark pb-2 mb-2 mt-1">
                While completion of Form WH-347 is optional, it is mandatory for covered contractors and subcontractors
                performing work on Federally financed or assisted construction contracts to respond to the information
                collection contained in 29 C.F.R. §§ 3.3, 5.5(a). The Copeland Act
                (40 U.S.C. § 3145) contractors and subcontractors performing work on Federally financed or assisted
                construction contracts to "furnish weekly a statement with respect to the wages paid each employee
                during
                the preceding week." U.S. Department of Labor (DOL) regulations at
                29 C.F.R. § 5.5(a)(3)(ii) require contractors to submit weekly a copy of all payrolls to the Federal
                agency
                contracting for or financing the construction project, accompanied by a signed "Statement of Compliance"
                indicating that the payrolls are correct and complete and that each laborer
                or mechanic has been paid not less than the proper Davis-Bacon prevailing wage rate for the work
                performed.
                DOL and federal contracting agencies receiving this information review the information to determine that
                employees have received legally required wages and fringe benefits.
                <b class="d-block text-center my-2">Public Burden Statement</b>
                We estimate that is will take an average of 55 minutes to complete this collection, including time for
                reviewing instructions, searching existing data sources, gathering and maintaining the data needed, and
                completing and reviewing the collection of information. If you have
                any comments regarding these estimates or any other aspect of this collection, including suggestions for
                reducing this burden, send them to the Administrator, Wage and Hour Division, U.S. Department of Labor,
                Room
                S3502, 200 Constitution Avenue, N.W.
                Washington, D.C. 20210
            </div>


        </div>
    </b-modal>
</template>
<script>
import { mapState } from 'vuex';
import faker from 'faker';

export default {
    name: 'PayrollForm',
    computed: {
        ...mapState(['workers']),
    },
    data() {
        return {
            name_type: 'contractor',
            name: 'Demo Company Inc.',
            address: '9180 Chapel RoadEaston, MD 21601',
            payroll_no: '12345',
            week_ending: this.moment().startOf('isoWeek').format('MM/DD/YYYY'),
            project_location: 'Rivanna Solar Project',
            project_no: 'GREELEY-CONCRETE',
            faker: faker,
            show: false,
        }
    },
}
</script>
<style scoped lang="scss" rel="stylesheet/scss">
table tr td {
    border: 1px solid #808184;
    padding: 5px;

    &:first-child {
        border-left: 0;
    }

    &:last-child {
        border-right: 0;
    }
}

.checkbox {
    width: 20px;
    height: 20px;
    background: #CFCFE9;
    display: inline-block;
    vertical-align: middle;
    position: relative;
}

.checked:after {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    content: "\274c";
    /* use the hex value here... */
    font-size: 12px;
    color: #FFF;
    line-height: 20px;
    text-align: center;
}

.input {
    min-height: 23px;
    background: #CFCFE9;
    padding: 1px 10px;
}


</style>